const isSingleItem = item => !Array.isArray(item);
export { isSingleItem };
